import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fb808c04"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = { class: "bank-card__top" }
const _hoisted_3 = { class: "bank-card__logo-bg" }
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = { class: "bank-card__title" }
const _hoisted_6 = {
  key: 0,
  class: "bank-card__default"
}
const _hoisted_7 = {
  key: 0,
  class: "bank-card__number"
}
const _hoisted_8 = {
  key: 1,
  class: "bank-card__sheba"
}
const _hoisted_9 = { class: "bank-card__bottom" }
const _hoisted_10 = { class: "bank-card__author" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "19",
  height: "20"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    fill: "#FFF",
    d: "M17.664 4.98H1.86C.681 4.98.353 4.645.353 4.231s.328-.749 1.507-.749h2.42c.418-.001 1.29-.302.86-.721l.238-1.214C5.598.64 6.392.2 7.305.1h4.139c.898 0 1.685.515 1.918 1.402l.248 1.259c.083.418.91.72.859.721h3.195c1.026 0 .733.335.733.749s.293.749-.733.749zm-5.492-1.42-.238-1.719a.511.511 0 0 0-.488-.345H7.305c.405-.001-.439.16-.5.391L6.577 3.56c-.03-.35-.106-.219-.163-.078h5.921c-.057-.141-.133-.272-.163.078zM2.376 6.709h.004a.758.758 0 0 1 .792.686c0 .068.531 6.73 1.628 9.545-.805.811-.172 1.481.623 1.494.036.001.072 0 .108-.002 2.444.053 4.938.056 7.625.006.807.069 1.517-.543 1.585-.728.004-.46.005-.731.005-.777.744-2.791.831-9.47.837-9.538a.754.754 0 0 1 .787-.686c.404.033 1.37.394 1.05.807-.05.068-.913 6.77-1.218 10.464-.071.752-1.421 2.02-3.021 1.956-1.303.023-2.56.036-3.789.036-.712 0-2.616-.015-3.893-.042-1.57.029-2.878-1.223-2.951-2.826-.308-2.836-.835-9.521-.842-9.588a.744.744 0 0 1 .67-.807zm7.016 13.263h.001-.001z"
  })
], -1))
const _hoisted_12 = [
  _hoisted_11
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "bank-card",
    style: _normalizeStyle({ backgroundColor: _ctx.color })
  }, [
    _createElementVNode("img", {
      class: "bank-card__bg",
      src: require('@/assets/images/bank-card-bg.png')
    }, null, 8, _hoisted_1),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          class: "bank-card__logo",
          src: _ctx.logo,
          alt: _ctx.bank
        }, null, 8, _hoisted_4)
      ]),
      _createElementVNode("div", _hoisted_5, "بانک " + _toDisplayString(_ctx.bank), 1),
      (_ctx.isDefault)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, "پیش فرض"))
        : (!_ctx.isDefault && _ctx.sheba)
          ? (_openBlock(), _createElementBlock("button", {
              key: 1,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('set-default'))),
              class: "bank-card__default-btn"
            }, " پیش فرض "))
          : _createCommentVNode("", true)
    ]),
    (_ctx.number)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.number, (num, index) => {
            return (_openBlock(), _createElementBlock("span", { key: index }, _toDisplayString(num), 1))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (!_ctx.number && _ctx.sheba)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.sheba), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", null, [
      (_ctx.number && _ctx.sheba)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            style: _normalizeStyle([!_ctx.sheba && { visibility: 'hidden' }]),
            class: "bank-card__sheba"
          }, _toDisplayString(_ctx.sheba), 5))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.author), 1),
        _createElementVNode("button", {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('remove'))),
          class: "bank-card__delete-btn"
        }, _hoisted_12)
      ])
    ])
  ], 4))
}